<template>
<div id="newsletter-type-subscriber-create">
  <h2>
    Create Newsletter Type Subscriber
  </h2>

  <newsletter-type-nav
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-nav>

  <hr />

  <newsletter-type-subscriber-form
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-subscriber-form>
</div>
</template>

<script>
import NewsletterTypeNav from '@/components/NewsletterTypeNav'
import NewsletterTypeSubscriberForm from '@/components/NewsletterTypeSubscriberForm'

export default {
  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    'newsletter-type-subscriber-form': NewsletterTypeSubscriberForm
  },

  props: [
    'newsletterTypeId'
  ]

}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriberCreate.vue